module.exports = __webpack_public_path__ + "6519d12950c8b4bca4802d4552710da9.png";